__turbopack_context__.v({
  "board": "planning-wall-visual-module__CdQP1W__board",
  "body": "planning-wall-visual-module__CdQP1W__body",
  "cell": "planning-wall-visual-module__CdQP1W__cell",
  "checkbox": "planning-wall-visual-module__CdQP1W__checkbox",
  "checkboxChecked": "planning-wall-visual-module__CdQP1W__checkboxChecked",
  "chip": "planning-wall-visual-module__CdQP1W__chip",
  "chipAvatar": "planning-wall-visual-module__CdQP1W__chipAvatar",
  "chipVisible": "planning-wall-visual-module__CdQP1W__chipVisible",
  "clientCount": "planning-wall-visual-module__CdQP1W__clientCount",
  "deadline": "planning-wall-visual-module__CdQP1W__deadline",
  "filterBar": "planning-wall-visual-module__CdQP1W__filterBar",
  "filterIcon": "planning-wall-visual-module__CdQP1W__filterIcon",
  "filterIconActive": "planning-wall-visual-module__CdQP1W__filterIconActive",
  "hideNarrow": "planning-wall-visual-module__CdQP1W__hideNarrow",
  "narrowOnly": "planning-wall-visual-module__CdQP1W__narrowOnly",
  "option": "planning-wall-visual-module__CdQP1W__option",
  "optionDimmed": "planning-wall-visual-module__CdQP1W__optionDimmed",
  "owner": "planning-wall-visual-module__CdQP1W__owner",
  "panel": "planning-wall-visual-module__CdQP1W__panel",
  "panelCol": "planning-wall-visual-module__CdQP1W__panelCol",
  "panelColLast": "planning-wall-visual-module__CdQP1W__panelColLast",
  "panelHead": "planning-wall-visual-module__CdQP1W__panelHead",
  "panelMonths": "planning-wall-visual-module__CdQP1W__panelMonths",
  "panelOpen": "planning-wall-visual-module__CdQP1W__panelOpen",
  "panelTags": "planning-wall-visual-module__CdQP1W__panelTags",
  "recount": "planning-wall-visual-module__CdQP1W__recount",
  "root": "planning-wall-visual-module__CdQP1W__root",
  "row": "planning-wall-visual-module__CdQP1W__row",
  "rowHidden": "planning-wall-visual-module__CdQP1W__rowHidden",
  "stat": "planning-wall-visual-module__CdQP1W__stat",
  "tightHead": "planning-wall-visual-module__CdQP1W__tightHead",
  "wideOnly": "planning-wall-visual-module__CdQP1W__wideOnly",
});
